import LogoutButton from '@/components/LogoutButton'
import NavItem from '@/components/NavItem'
import { useAppSelector } from '@/store/store.ts'
import { Link } from 'react-router-dom'

export default function Header() {
	const user = useAppSelector(({ auth }) => auth.user)

	if (user !== undefined) {
		const navLinkClass = 'text-white no-underline px-4 py-6 hover:bg-colourSky80'
		const navLinkActiveClass = 'bg-colourSky80'

		const userNavLinkClass = 'text-white no-underline px-4 py-6 hover:bg-colourSky80 uppercase'
		// const userNavLinkActiveClass = 'text-colourSky80'

		return (
			<header className="flex flex-row justify-between mx-5">
				<div className="flex flex-row gap-2">
					<h1 className="my-2">
						<Link
							to="/contacts/search"
							title="Telstra Awards CRM"
							className="bg-[url('/images/Telstra_Best_of_Business_Awards_Horiz_Logo_A_RGB.png')] block h-[55px] w-[200px] bg-contain bg-bottom bg-no-repeat"
						>
							<span className="block indent-[-9999em]">Telstra Awards CRM</span>
						</Link>
					</h1>
					<nav className="flex">
						<NavItem
							href={'/contacts/search'}
							label={'Contacts'}
							highlightMatch={'/contacts/'}
							className={navLinkClass}
							activeClassName={navLinkActiveClass}
						/>
						<NavItem
							href={'/nominations/search'}
							label={'Nominations'}
							highlightMatch={'/nominations/'}
							className={navLinkClass}
							activeClassName={navLinkActiveClass}
						/>
						<NavItem
							href={'/entries/search'}
							label={'Entries'}
							highlightMatch={'/entries/'}
							className={navLinkClass}
							activeClassName={navLinkActiveClass}
						/>
						<NavItem
							href={'/judges/search'}
							label={'Judges'}
							highlightMatch={'/judges/'}
							className={navLinkClass}
							activeClassName={navLinkActiveClass}
						/>
						<NavItem
							href={'/enquiries/search'}
							label={'Web Enquiries'}
							highlightMatch={'/enquiries/'}
							className={navLinkClass}
							activeClassName={navLinkActiveClass}
						/>
						<NavItem
							href={'/reports/summary-reports'}
							label={'Reports'}
							highlightMatch={'/reports/'}
							className={navLinkClass}
							activeClassName={navLinkActiveClass}
						/>
					</nav>
				</div>
				<div>
					<nav className="flex">
						<NavItem
							href={'/awards/search'}
							label={'Awards'}
							highlightMatch={'/awards/'}
							className={userNavLinkClass}
							activeClassName={navLinkActiveClass}
						/>
						<NavItem
							href={'/access/employees'}
							label={'Access'}
							highlightMatch={'/access/'}
							className={userNavLinkClass}
							activeClassName={navLinkActiveClass}
						/>
						<LogoutButton />
					</nav>
				</div>
			</header>
		)
	} else {
		return (
			<header className="pl-[10px] indent-[-9999em]">
				<h1 className="my-0">
					<Link
						to="/auth/login"
						title="Telstra Awards CRM"
						className="bg-[url('/images/Telstra_Best_of_Business_Awards_Horiz_Logo_A_RGB.png')] block h-[55px] w-[200px] bg-contain bg-bottom bg-no-repeat"
					>
						Telstra Awards CRM
					</Link>
				</h1>
			</header>
		)
	}
}
